export const summaryStats = [
  { id: 1, title: 'Total Students', value: '342', change: '+12 this month', icon: 'FiUsers', trend: 'up', color: 'blue' },
  { id: 2, title: "Today's Attendance", value: '96.4%', change: '-0.5% vs yesterday', icon: 'FiCheckCircle', trend: 'down', color: 'orange' },
  { id: 3, title: 'Active Classes', value: '24', change: 'Current session', icon: 'FiBookOpen', trend: 'neutral', color: 'blue' },
  { id: 4, title: 'Pending Requests', value: '8', change: 'Requires attention', icon: 'FiAlertCircle', trend: 'neutral', color: 'orange' },
];

export const scheduleData = [
  { id: 1, time: '08:00 AM', duration: '90m', subject: 'Advanced Mathematics', teacher: 'Dr. Sarah Jenkins', room: 'Lab 402', status: 'completed' },
  { id: 2, time: '09:45 AM', duration: '60m', subject: 'Creative Writing', teacher: 'Prof. Mark L.', room: 'Room 105', status: 'in-progress' },
  { id: 3, time: '11:00 AM', duration: '45m', subject: 'Physics 101', teacher: 'Dr. Alan Grant', room: 'Lab 301', status: 'upcoming' },
  { id: 4, time: '01:00 PM', duration: '90m', subject: 'Computer Science', teacher: 'Ms. Ada Lovelace', room: 'Tech Hub', status: 'upcoming' },
];

export const announcements = [
  { id: 1, title: 'Campus Wi-Fi Maintenance', date: 'Today, 2:00 PM', type: 'System', priority: 'high' },
  { id: 2, title: 'New Staff Onboarding Meeting', date: 'Tomorrow, 9:00 AM', type: 'Admin', priority: 'normal' },
  { id: 3, title: 'Updated Health Guidelines', date: 'Oct 24, 2024', type: 'Health', priority: 'high' },
];

export const staffTasks = [
  { id: 1, task: 'Review Q3 Budget Proposals', assignee: 'Principal Office', status: 'Pending', dueDate: 'Today' },
  { id: 2, task: 'Order New Whiteboards (Room 12-15)', assignee: 'Facilities', status: 'In Progress', dueDate: 'Tomorrow' },
  { id: 3, task: 'Finalize Semester Schedule', assignee: 'Academic Coord.', status: 'Completed', dueDate: 'Yesterday' },
];

export const parentMessages = [
  { id: 1, parent: 'Elena Rodriguez', student: 'Mateo R. (Grade 8)', message: 'Will Mateo need to bring his laptop for the field trip?', time: '10m ago', unread: true },
  { id: 2, parent: 'David Chen', student: 'Lily C. (Grade 5)', message: 'Lily is feeling unwell and will be absent today.', time: '1h ago', unread: true },
  { id: 3, parent: 'Sarah Smith', student: 'John S. (Grade 10)', message: 'Thank you for the detailed progress report.', time: 'Yesterday', unread: false },
];

export const faqs = [
  {
    question: "What is EduOps exactly?",
    answer: "EduOps is an all-in-one School Operations System (SOS) designed specifically for small to mid-sized schools and training centers. It replaces fragmented spreadsheets and paper logs with a unified, futuristic digital core for managing students, staff, and parents."
  },
  {
    question: "How is the dummy data generated?",
    answer: "All data seen in this demo (students, schedules, and messages) is procedurally generated local state. No real student or personal information is stored or transmitted. This allows you to explore the interface safely in a sandbox environment."
  },
  {
    question: "Is there a real back-end for this demo?",
    answer: "No, this is a 'Live Product Simulation'. Every interaction—from marking attendance to resource requests—is handled by local state logic to demonstrate the UX flow without requiring a server connection or account creation."
  },
  {
    question: "Who is the target user for EduOps?",
    answer: "Our platform is optimized for educational administrators, registrars, and faculty leads at private academies, vocational schools, and specialized training centers who need enterprise-grade tools without enterprise-grade complexity."
  },
  {
    question: "Can I customize the branding and modules?",
    answer: "Yes! While this demo uses our signature 'Principal Blue' and 'Bell Orange' palette, the actual product features a white-label engine that allows institutions to apply their own brand identity and toggle specific operational modules as needed."
  }
];

export const attendanceChartOptions = {
  backgroundColor: 'transparent',
  tooltip: {
    trigger: 'axis',
    backgroundColor: 'rgba(15, 23, 42, 0.9)',
    borderColor: '#334155',
    textStyle: { color: '#f8fafc' }
  },
  grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
    axisLine: { lineStyle: { color: '#475569' } },
    axisLabel: { color: '#94a3b8' }
  },
  yAxis: {
    type: 'value',
    min: 85,
    max: 100,
    axisLine: { show: false },
    splitLine: { lineStyle: { color: '#1e293b', type: 'dashed' } },
    axisLabel: { color: '#94a3b8', formatter: '{value}%' }
  },
  series: [
    {
      name: 'Attendance Rate',
      type: 'line',
      smooth: true,
      data: [98.2, 97.5, 96.8, 98.9, 96.4],
      itemStyle: { color: '#3b82f6' },
      areaStyle: {
        color: {
          type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [
            { offset: 0, color: 'rgba(59, 130, 246, 0.5)' },
            { offset: 1, color: 'rgba(59, 130, 246, 0.0)' }
          ]
        }
      },
      lineStyle: { width: 3, shadowColor: 'rgba(59,130,246,0.5)', shadowBlur: 10 }
    }
  ]
};

export const quickAttendanceStudents = [
  { id: 1, name: 'Alex Johnson', grade: 'Grade 10', present: true },
  { id: 2, name: 'Brian Smith', grade: 'Grade 10', present: true },
  { id: 3, name: 'Chloe Davis', grade: 'Grade 10', present: false },
  { id: 4, name: 'Daniel Wilson', grade: 'Grade 10', present: true },
  { id: 5, name: 'Emma Brown', grade: 'Grade 10', present: true },
];